<template>
	<div class="animated fadeIn">
		<AccountDetailComponent v-bind:accountSelected="accountSelected"
								v-bind:loading="loading"></AccountDetailComponent>

		<b-row class="justify-content-center" v-if="!loading">
			<b-col v-if="checkModule(WEB_MODULES_PROFILE)" cols="12" sm="6" lg="3">
				<b-card :no-body="true" footer-class="px-3 py-2">
					<b-card-body class="p-3 clearfix">
						<i class="fa fa-pencil-square-o bg-primary p-3 font-2xl mr-3 float-left"></i>
						<div class="h5 text-primary mb-0 mt-2">Actualizar Información</div>
						<div class="text-muted text-uppercase font-weight-bold font-xs"></div>
					</b-card-body>
					<div slot="footer">
						<router-link class="font-weight-bold font-xs btn-block text-muted"
									 :to="{name: 'AccountUpdate'}">
							Actualizar <i class="fa fa-angle-right float-right font-lg"></i></router-link>
					</div>
				</b-card>
			</b-col>


			<b-col v-if="checkModule(WEB_MODULES_INCIDENTS)" cols="12" sm="6" lg="3">
				<b-card :no-body="true" footer-class="px-3 py-2">
					<b-card-body class="p-3 clearfix">
						<i class="fa fa-book bg-primary p-3 font-2xl mr-3 float-left"></i>
						<div class="h5 text-primary mb-0 mt-2">Casos ({{accountInfo.IncidentsCount}})</div>
						<div class="text-muted text-uppercase font-weight-bold font-xs"></div>
					</b-card-body>
					<div slot="footer">
						<router-link class="font-weight-bold font-xs btn-block text-muted" :to="{name: 'IncidentList'}">
							Ver Casos <i class="fa fa-angle-right float-right font-lg"></i></router-link>
					</div>
				</b-card>
			</b-col>

			<b-col v-if="checkModule(WEB_MODULES_WORKSHOP_INCIDENTS)" cols="12" sm="6" lg="3">
				<b-card :no-body="true" footer-class="px-3 py-2">
					<b-card-body class="p-3 clearfix">
						<i class="fa fa-building bg-primary p-3 font-2xl mr-3 float-left"></i>
						<div class="h5 text-primary mb-0 mt-2">Casos de Taller
							({{accountInfo.WorkshopIncidentsCount}})
						</div>
						<div class="text-muted text-uppercase font-weight-bold font-xs"></div>
					</b-card-body>
					<div slot="footer">
						<router-link class="font-weight-bold font-xs btn-block text-muted"
									 :to="{name: 'WorkshopIncidents'}">
							Ver Casos <i class="fa fa-angle-right float-right font-lg"></i></router-link>
					</div>
				</b-card>
			</b-col>

			<b-col v-if="checkModule(WEB_MODULES_CDT)" cols="12" sm="6" lg="3">
				<b-card :no-body="true" footer-class="px-3 py-2">
					<b-card-body class="p-3 clearfix">
						<i class="fa fa-briefcase bg-primary p-3 font-2xl mr-3 float-left"></i>
						<div class="h5 text-primary mb-0 mt-2">Comienzos de Trabajo
							({{accountInfo.WorkProjectsCount}})
						</div>
						<div class="text-muted text-uppercase font-weight-bold font-xs"></div>
					</b-card-body>
					<div slot="footer">
						<router-link class="font-weight-bold font-xs btn-block text-muted" :to="{name: 'WorkProjects'}">
							Ver CDT'S <i class="fa fa-angle-right float-right font-lg"></i></router-link>
					</div>
				</b-card>
			</b-col>

			<b-col v-if="checkModule(WEB_MODULES_MAINTENANCE_CONTRACTS)" cols="12" sm="6" lg="3">
				<b-card :no-body="true" footer-class="px-3 py-2">
					<b-card-body class="p-3 clearfix">
						<i class="fa fa-wrench bg-primary p-3 font-2xl mr-3 float-left"></i>
						<div class="h5 text-primary mb-0 mt-2">Contratos de Mantenimiento
							({{accountInfo.MaintenanceContractsCount}})
						</div>
						<div class="text-muted text-uppercase font-weight-bold font-xs"></div>
					</b-card-body>
					<div slot="footer">
						<router-link class="font-weight-bold font-xs btn-block text-muted"
									 :to="{name: 'MaintenanceContracts'}">Ver Contratos <i
							class="fa fa-angle-right float-right font-lg"></i></router-link>
					</div>
				</b-card>
			</b-col>

			<b-col v-if="checkModule(WEB_MODULES_CONTRACTS)" cols="12" sm="6" lg="3">
				<b-card :no-body="true" footer-class="px-3 py-2">
					<b-card-body class="p-3 clearfix">
						<i class="fa fa-file-video-o bg-primary p-3 font-2xl mr-3 float-left"></i>
						<div class="h5 text-primary mb-0 mt-2">Contratos de Monitoreo ({{accountInfo.ContractsCount}})
						</div>
						<div class="text-muted text-uppercase font-weight-bold font-xs"></div>
					</b-card-body>
					<div slot="footer">
						<router-link class="font-weight-bold font-xs btn-block text-muted" :to="{name: 'Contracts'}">Ver
							Contratos <i class="fa fa-angle-right float-right font-lg"></i></router-link>
					</div>
				</b-card>
			</b-col>

			<b-col v-if="checkModule(WEB_MODULES_QUOTES)" cols="12" sm="6" lg="3">
				<b-card :no-body="true" footer-class="px-3 py-2">
					<b-card-body class="p-3 clearfix">
						<i class="fa fa-file-text-o bg-primary p-3 font-2xl mr-3 float-left"></i>
						<div class="h5 text-primary mb-0 mt-2">Cotizaciones ({{accountInfo.QuoteCount}})</div>
						<div class="text-muted text-uppercase font-weight-bold font-xs"></div>
					</b-card-body>
					<div slot="footer">
						<router-link class="font-weight-bold font-xs btn-block text-muted" :to="{name: 'Quotes'}">Ver
							Cotizaciones <i class="fa fa-angle-right float-right font-lg"></i></router-link>
					</div>
				</b-card>
			</b-col>

			<b-col v-if="checkModule(WEB_MODULES_CLIENT_PRODUCTS)" cols="12" sm="6" lg="3">
				<b-card :no-body="true" footer-class="px-3 py-2">
					<b-card-body class="p-3 clearfix">
						<i class="fa fa-video-camera bg-primary p-3 font-2xl mr-3 float-left"></i>
						<div class="h5 text-primary mb-0 mt-2">Equipos del Cliente
							({{accountInfo.ClientProductsCount}})
						</div>
						<div class="text-muted text-uppercase font-weight-bold font-xs"></div>
					</b-card-body>
					<div slot="footer">
						<router-link class="font-weight-bold font-xs btn-block text-muted"
									 :to="{name: 'ClientProductList'}">Ver Equipos <i
							class="fa fa-angle-right float-right font-lg"></i></router-link>
					</div>
				</b-card>
			</b-col>

			<b-col v-if="checkModule(WEB_MODULES_INVOICES)" cols="12" sm="6" lg="3">
				<b-card :no-body="true" footer-class="px-3 py-2">
					<b-card-body class="p-3 clearfix">
						<i class="fa fa-file-text bg-primary p-3 font-2xl mr-3 float-left"></i>
						<div class="h5 text-primary mb-0 mt-2">Facturas ({{accountInfo.InvoicesCount}})</div>
						<div class="text-muted text-uppercase font-weight-bold font-xs"></div>
					</b-card-body>
					<div slot="footer">
						<router-link class="font-weight-bold font-xs btn-block text-muted" :to="{name: 'Invoices'}">Ver
							Facturas <i class="fa fa-angle-right float-right font-lg"></i></router-link>
					</div>
				</b-card>
			</b-col>

			<b-col v-if="checkModule(WEB_MODULES_TICKETS)" cols="12" sm="6" lg="3">
				<b-card :no-body="true" footer-class="px-3 py-2">
					<b-card-body class="p-3 clearfix">
						<i class="fa fa-ticket bg-primary p-3 font-2xl mr-3 float-left"></i>
						<div class="h5 text-primary mb-0 mt-2">Tickets ({{accountInfo.TicketsCount}})</div>
						<div class="text-muted text-uppercase font-weight-bold font-xs"></div>
					</b-card-body>
					<div slot="footer">
						<router-link class="font-weight-bold font-xs btn-block text-muted" :to="{name: 'Tickets'}">Ver
							Tickets <i class="fa fa-angle-right float-right font-lg"></i></router-link>
					</div>
				</b-card>
			</b-col>

			<b-col v-if="checkModule(WEB_MODULES_TICKETS)" cols="12" sm="6" lg="3">
				<b-card :no-body="true" footer-class="px-3 py-2">
					<b-card-body class="p-3 clearfix">
						<i class="fa fa-suitcase bg-primary p-3 font-2xl mr-3 float-left"></i>
						<div class="h5 text-primary mb-0 mt-2">Viáticos ({{accountInfo.TravelExpenseCount}})</div>
						<div class="text-muted text-uppercase font-weight-bold font-xs"></div>
					</b-card-body>
					<div slot="footer">
						<router-link class="font-weight-bold font-xs btn-block text-muted" :to="{name: 'TravelExpenseList'}">
							Ver Viáticos <i class="fa fa-angle-right float-right font-lg"></i></router-link>
					</div>
				</b-card>
			</b-col>

			<b-col v-if="checkModule(WEB_MODULES_TICKETS)" cols="12" sm="6" lg="3">
				<b-card :no-body="true" footer-class="px-3 py-2">
					<b-card-body class="p-3 clearfix">
						<i class="fa fa-globe bg-primary p-3 font-2xl mr-3 float-left"></i>
						<div class="h5 text-primary mb-0 mt-2">Zonificación ({{accountInfo.ZoningCount}})</div>
						<div class="text-muted text-uppercase font-weight-bold font-xs"></div>
					</b-card-body>
					<div slot="footer">
						<router-link class="font-weight-bold font-xs btn-block text-muted" :to="{name: 'ZoningList'}">
							Ver Zonificación <i class="fa fa-angle-right float-right font-lg"></i></router-link>
					</div>
				</b-card>
			</b-col>

		</b-row>
	</div>
</template>

<script>
	import AccountDetailComponent from '../components/AccountDetailComponent';
	import {mapState} from "vuex";
	import {
		WEB_MODULES_CDT,
		WEB_MODULES_CLIENT_PRODUCTS,
		WEB_MODULES_CONTRACTS,
		WEB_MODULES_INCIDENTS,
		WEB_MODULES_INVOICES,
		WEB_MODULES_MAINTENANCE_CONTRACTS,
		WEB_MODULES_OPPORTUNITIES,
		WEB_MODULES_PROFILE,
		WEB_MODULES_QUOTES,
		WEB_MODULES_TICKETS,
		WEB_MODULES_WORKSHOP_INCIDENTS
	} from "@/constans";

	export default {
		name: "AccountDetail",
		components: {
			AccountDetailComponent
		},
		data: function () {
			return {
				accountSelected: '',
				loading: false,
				accountInfo: '',
				userModules: [],
				WEB_MODULES_CDT: WEB_MODULES_CDT,
				WEB_MODULES_CLIENT_PRODUCTS: WEB_MODULES_CLIENT_PRODUCTS,
				WEB_MODULES_CONTRACTS: WEB_MODULES_CONTRACTS,
				WEB_MODULES_INCIDENTS: WEB_MODULES_INCIDENTS,
				WEB_MODULES_INVOICES: WEB_MODULES_INVOICES,
				WEB_MODULES_MAINTENANCE_CONTRACTS: WEB_MODULES_MAINTENANCE_CONTRACTS,
				WEB_MODULES_OPPORTUNITIES: WEB_MODULES_OPPORTUNITIES,
				WEB_MODULES_PROFILE: WEB_MODULES_PROFILE,
				WEB_MODULES_QUOTES: WEB_MODULES_QUOTES,
				WEB_MODULES_TICKETS: WEB_MODULES_TICKETS,
				WEB_MODULES_WORKSHOP_INCIDENTS: WEB_MODULES_WORKSHOP_INCIDENTS
			}
		},
		mounted() {
			const accountID = this.$route.params.id;
			this.loginAccount(accountID);
			this.userModules = JSON.parse(localStorage.getItem('userModules'));
		},
		methods: {
			loginAccount(accountID) {
				this.loading = true;
				this.$store.dispatch('loginAccount', {accountID})
					.then((resp) => {
						this.accountSelected = this.$store.state.accountSelected;
						this.getAccountInfo();
					})
					.finally(() => {
						this.loading = false;
					});
			},
			getAccountInfo() {
				this.loading = true;

				this.$store.dispatch('getAccountInfo', {})
					.then((resp) => {
						this.accountInfo = resp;
					})
					.finally(() => {
						this.loading = false;
					});
			},
			checkModule(module) {
				return this.userModules.some(userModule => userModule.WebModule === module)
			}
		}
	}
</script>

<style scoped>

</style>
